export default {
  placeholder: 'Search brand...',
};
